import { FormikErrors } from "formik";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import SkillModal from "../../../components/features/SkillModal";
import StudyRecordSkillForm from "../../../components/features/StudyRecordSkillForm/index";
import { UnprocessableEntityError } from "../../../errors";
import FiltersHelper from "../../../helpers/FiltersHelper";
import { AuthenticatedPageProps } from "../../../hocs/enhanceAuthenticatedPage";
import { useFlashMessage } from "../../../hooks/useFlashMessage";
import { ApiErrorInterface } from "../../../interfaces/ApiErrorResponseInterface";
import SectionInterface from "../../../interfaces/SectionInterface";
import SkillInterface from "../../../interfaces/SkillInterface";
import { StudyRecordSkillParamsInterface } from "../../../interfaces/StudyRecordSkillInterface";
import { useUpdateSkill } from "../useUpdateSkill";

type Props = {
  skill: SkillInterface;
  section: SectionInterface;
} & Pick<AuthenticatedPageProps, "studentFilterContext">;

const SectionsSettingsStudyRecordSkillsEditPage: React.FC<Props> = (props) => {
  const sectionId = props.section.id;

  const [showModal, setShowModal] = React.useState(false);
  const [apiErrors, setApiErrors] = React.useState<ApiErrorInterface[]>([]);
  const navigate = useNavigate();

  const { showErrorMessage } = useFlashMessage();

  const tags = FiltersHelper.getAllTags(
    props.studentFilterContext.currentFilter,
  );

  const updateSkillMutation = useUpdateSkill({
    sectionId: props.section.id,
    skillId: props.skill.id,
  });

  const handleSubmit = (
    params: StudyRecordSkillParamsInterface,
    setSubmitting: (submitState: boolean) => void,
    setErrors: (errors: FormikErrors<any>) => void,
  ) => {
    setSubmitting(true);
    setErrors({});
    setApiErrors([]);

    updateSkillMutation.mutate(params, {
      onSettled: () => {
        setSubmitting(false);
      },
      onSuccess: () => {
        setErrors({});
        setApiErrors([]);
        setShowModal(true);
      },
      onError: (error) => {
        showErrorMessage("スキルを更新できませんでした");
        if (error instanceof UnprocessableEntityError) {
          setApiErrors(error.originalErrors);
          setErrors(
            error.originalErrors.reduce<FormikErrors<any>>((acc, error) => {
              if (error.field) {
                acc[error.field] = error.message;
              }
              return acc;
            }, {}),
          );
        }
      },
    });
  };

  const navigateToSkillIndexPage = () => {
    setShowModal(false);
    navigate(`/sections/${sectionId}/settings/skills`);
  };

  return (
    <>
      <StudyRecordSkillForm
        skill={props.skill}
        sectionId={sectionId}
        skillMasterId={props.skill.skillMaster.id}
        action="edit"
        tags={tags}
        onSubmit={handleSubmit}
        submitting={updateSkillMutation.isPending}
        apiErrors={apiErrors}
        heading={`${props.skill.skillMaster.name}編集`}
        helpUrl="https://fs-help.studyplus.co.jp/ja/articles/4250110-%E5%AD%A6%E7%BF%92%E6%99%82%E9%96%93%E3%81%AE%E3%81%8A%E7%9F%A5%E3%82%89%E3%81%9B%E3%82%B9%E3%82%AD%E3%83%AB%E3%81%AE%E8%A8%AD%E5%AE%9A%E6%96%B9%E6%B3%95"
      />
      <SkillModal
        showModal={showModal}
        onComplete={navigateToSkillIndexPage}
        action="edit"
      />
    </>
  );
};

export default SectionsSettingsStudyRecordSkillsEditPage;
